import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectGlobalOrgRegistryMappingsListItems } from "../../../../../../redux/global-org-registry-mappings/selector";
import { globalOrgRegistryMappings } from "../../../../../../redux/global-org-registry-mappings/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";


const DBNPOrgRegistryMappings = (selectedDbnpRegistry: any) => {
  console.log(selectedDbnpRegistry, 'selectedDbnpRegistry');
  
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10); 
  const dbnpMappingItems = useSelector(selectGlobalOrgRegistryMappingsListItems);


  const fieldName = selectedDbnpRegistry?.selectedDbnpRegistry?.IsProxyNetwork 
    ? "GlobalOrgRegistryDBNPId" 
    : "InternalDBNPId";

  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(params.node.id, 10) + 1;
        },
      },
      { field: 'InternalDBNIEName', headerName: 'Internal DBNIE Name'},
      { field: 'InternalDBNPName', headerName: 'Internal DBNP Name'},
      { field: 'GlobalOrgRegistryDBNIEName', headerName: 'Global Org Registry DBNIE Name'},
      { field: 'GlobalOrgRegistryDBNPName', headerName: 'Global Org Registry DBNP', searchField: 'GlobalProviderDBNPName', filter: true, filterType: 'text'}, 
      { field: 'GlobalOrgRegistryName', headerName: 'Global Org Registry Name', searchField: 'GlobalProviderDBNPName', filter: true, filterType: 'text'}, 
    ]);
  };

  const handleSearch = (data: any) => {
    console.log('Search data', data);
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value,
      }];
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value,
      }];
    }

    dispatch(globalOrgRegistryMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/fetch`,
      entity: 'globalOrgRegistryMappings',
      jsonData: {
        "Context": {},
        "Records": [
          {
            [fieldName]: selectedDbnpRegistry?.selectedDbnpRegistry?.DBNPId,
          }
        ],
        "Pagination": {
          PageNumber: 1,
          PageSize: 50,
          SortField: 'Id',
          SortOrder: 'desc',
        },
      },
    }));
  };

  const handleReloadData = () => {
    dispatch(globalOrgRegistryMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/fetch`,
      entity: 'globalOrgRegistryMappings',
      jsonData: {
        "Context": {},
        "Records": [
          {
            [fieldName]: selectedDbnpRegistry?.selectedDbnpRegistry?.DBNPId,
          }
        ],
        "Pagination": {
          PageNumber: 1,
          PageSize: 50,
          SortField: 'Id',
          SortOrder: 'desc',
        },
      },
    }));
  };

  const fetchDbnpMapping = () => {
    dispatch(globalOrgRegistryMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/fetch`,
      entity: 'globalOrgRegistryMappings',
      jsonData: {
        "Context": {},
        "Records": [
          {
            [fieldName]: selectedDbnpRegistry?.selectedDbnpRegistry?.DBNPId,
          }
        ],
        "Pagination": {
          PageNumber: 1,
          PageSize: 50,
          SortField: 'Id',
          SortOrder: 'desc',
        },
      },
    }));
  };

  const handleDelete = (data: any) => {
    dispatch(globalOrgRegistryMappings.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/delete`,
      entity: 'globalOrgRegistryMappings',
      jsonData: {
        Records: [
          {
            Id: data?.Id,
          }
        ],
      },
    })).then(() => {
      dispatch(globalOrgRegistryMappings.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/fetch`,
        entity: 'globalOrgRegistryMappings',
        jsonData: {
          "Filters": [
            {
              "FieldName": fieldName,
              "FilterOperatorId": 1,
              "FieldValue": selectedDbnpRegistry?.selectedDbnpRegistry?.DBNPId,
              "FieldType": "number",
            }
          ],
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        },
      }));
    });
  };

  const handleEdit = (data: any) => {
    navigate(`/management/organization/dbn/global-org-registry-mappings/accountId/${data?.GlobalOrgRegistryAccountId}/globalOrgRegistryId/${data?.GlobalOrgRegistryId}`);
  };

  const handleAdd = () => {
    navigate(`${0}`);
  };

  useEffect(() => {
    createColumnDefs();
    fetchDbnpMapping();
  }, [pageData, pageSize]);

  const additionButtons: any = [
    {
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      ),
      callback: () => handleReloadData(),
    },
  ];

  const filterTypes = [
    { name: 'Text', value: "text" },
    { name: 'Number', value: "number" },
    { name: 'CheckBox', value: "checkbox" },
    { name: 'Date', value: "date" }
  ];

  return (
    <>
      {dbnpMappingItems?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          enableFilter={true}
          additionButtons={additionButtons}
          filterTypeLists={filterTypes}
          onEdit={handleEdit}
          onSearch={handleSearch}
          columnData={columnDefs}
          rowData={dbnpMappingItems?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={dbnpMappingItems?.result?.pagination}
          headingName="Org Registry Mappings"
        />
      )}
    </>
  );
};

export default DBNPOrgRegistryMappings;



